import { compressToURI } from 'lz-ts';
import { useNavigate } from 'react-router-dom';
import { AnalyticSearchRequestDto, FiltersRequestDto } from 'src/generated/services/TFinancialApi';
import { ChartViewType } from 'src/presentations/components/organisms/analytics/sidebar/types';
import { stringify } from 'superjson';

export enum InvoicesStatus {
  UNRESOLVED = 'UNRESOLVED',
  RESOLVED = 'RESOLVED',
}

export const useNavigateToRnA = ({ provider, modality }) => {
  const navigate = useNavigate();
  const navigateToRnA = (invoicesStatus) => {
    const defaultFiltersState = {
      name: '',
      description: '',
      filters: {
        selectedChartView: ChartViewType.TREND,
        formValues: {
          granularity: 'DAILY',
          dateReference: 'PICKUP_DATE',
          filters: {
            dateFilters: {},
            tradeLaneFilters: {},
            shipmentFilters: {
              serviceProviderCode: [provider],
              modality: [modality],
            },
          },
          invoiceStatusSet: invoicesStatus === InvoicesStatus.UNRESOLVED ? ['FLAGGED'] : ['APPROVED', 'REJECTED'],
        } as AnalyticSearchRequestDto,
      },
    };
    const report = compressToURI(stringify(defaultFiltersState));
    navigate(`/analytics?report=${report}`);
  };

  const navigateToPerformance = (defaultCurrency: string) => {
    const defaultFiltersState = {
      filters: {
        selectedChartView: ChartViewType.TREND,
        formValues: {
          currencyReference: defaultCurrency,
          dateReference: 'PICKUP_DATE',
          filters: {
            dateFilters: {},
            tradeLaneFilters: {},
            shipmentFilters: {
              serviceProviderCode: [provider],
              modality: [modality],
            },
          },
          invoiceStatusSet: ['FLAGGED', 'APPROVED', 'REJECTED'],
        } as FiltersRequestDto,
      },
    };

    const report = compressToURI(stringify(defaultFiltersState));
    navigate(`/performance?report=${report}`);
  };

  return { navigateToRnA, navigateToPerformance };
};
